// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { documentsStyles } from "@stoneage/Overrides/Widgets/ProductDetails/ProductDetailsDocuments";
import IconFile from "@warthog/XDL/Icons/IconFile";
import IconVideo from "@warthog/XDL/Icons/IconVideo";
import { css } from "styled-components";

documentsStyles.title = {
    variant: 'h3',
    size: '24px',
    lineHeight: '28px',
    color: 'common.white',
    css: css`
        width: 100%;
        margin-bottom: 0;
    `,
};

documentsStyles.documentLink = {
    color: "common.black",
    typographyProps: {
        size: "15px",
        lineHeight: "18px",
        weight: "bold",
        ellipsis: true,
        css: css`
            width: 100%;
        `,
    },
    css: css`
        width: 100%;
    `,
};

documentsStyles.documentIcon = {
    src: IconFile,
    size: 12,
    css: css`
        margin-right: 5px;
    `,
};

documentsStyles.videoIcon = {
    src: IconVideo,
    size: 14,
    css: css`
        margin-right: 5px;
    `,
};

documentsStyles.sectionTitle = {
    size: '18px',
    lineHeight: '21px',
    color: 'common.ui12',
    transform: 'capitalize',
    weight: 'bold',
    css: css`
        margin-bottom: 12px;
        width: 100%;
    `,
};